module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Ghostly Tales of Amherst, New Hampshire")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")]), _vm._v(" & M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AP")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "70px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "320px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Welcome#Wel"
    }
  }, [_vm._v("Welcome to Spooky Amherst, New Hampshire!")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part1#P1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 1. Tales Passed Down Through the Years")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wolves in the Night")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Young Lovers’ Walk")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit Chair")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Superstitions")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mysterious Whipping Block on the Amherst Town Green")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part2#P2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 2. Ghostly Tales")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Friendly Ghost Who Saved the Barnabas David House")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Haunting of Town Hall")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghosts in the Green House")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts in the Doctor’s Mansion")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Haunted History of the Aaron Lawrence House")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost of the Spinster")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghosts of the John Watson Tavern")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost in Martin’s House")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reasons Why Karen & Joe Called Ghost Hunters")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter15#C15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter15#C15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nightly Rattlings of Mr. Pesterfield")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter16#C16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter16#C16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mischievous Ghost at the Blunt House")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter17#C17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter17#C17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost of Converse Farm")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter18#C18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter18#C18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children of the Lake")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part3#P3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 3. Indigenous Folklore")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter19#C19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter19#C19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lake Spirits")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter20#C20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter20#C20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The River Spirits")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter21#C21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter21#C21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Swamp Woman")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter22#C22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter22#C22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit of Joe English")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part4#P4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 4. Graves of the Past")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter23#C23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter23#C23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pauper’s Cemetery")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter24#C24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter24#C24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Burying Ground")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter25#C25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter25#C25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skeletons in the Basement")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/A_Ghostly_Goodbye#Gho",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Ghostly Goodbye")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/You_Still_Haunt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Still Haunt Me, a poem by Susanna Hargreaves")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0